/* ==========================================================================
   RACEM  |  racem-prefetch.js
   Potichu na pozadi (na kazdej stranke okrem Ponuky) naplni ten isty
   localStorage cache, ktory cita racem-ponuka.js. Vdaka tomu je otvorenie
   Ponuky okamzite, lebo data uz su stiahnute skor, kym clovek pozera napr.
   uvodnu stranku. Ziaden vplyv na rychlost aktualnej stranky, spusta sa az
   v case necinnosti prehliadaca.
   ========================================================================== */
(function () {
  'use strict';

  /* Na samotnej Ponuke nebezime, tam si data riesi racem-ponuka.js sam. */
  if (document.getElementById('racemOfferPage')) return;

  var cfg = document.getElementById('racem-prefetch-js');
  if (!cfg) return;

  /* Rovnaky ROOT fix ako v Ponuke: na primarnom jazyku vrati routes.root_url
     "/", takze koncove lomitka odrezeme, aby nevzniklo //products.json. */
  var ROOT = (cfg.dataset.root || '/').replace(/\/+$/, '');
  var LOCALE = cfg.dataset.locale || 'sk';

  /* Musi presne sediet s racem-ponuka.js, inak by sa cache nenaslo. */
  var CACHE_KEY = 'racem_offer_v37_' + LOCALE;
  var CACHE_TTL = 6 * 60 * 60 * 1000;
  var PAGE_TIMEOUT = 8000;
  var MAX_PAGES = 60;

  function cacheFresh() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      return !!(c && c.time && (Date.now() - c.time) < CACHE_TTL && Array.isArray(c.products) && c.products.length);
    } catch (e) {
      return false;
    }
  }

  /* Overenie, ci sa vobec da zapisat do localStorage. V in-app prehliadacoch
     (Instagram, Facebook) a v anonymnom rezime byva zablokovany, a vtedy nema
     prefetch zmysel, lebo Ponuka by cache aj tak nenacitala. */
  function storageWritable() {
    try {
      var k = '__rc_probe__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  function rcPickImage(p){
    var src='';
    if(Array.isArray(p.images)&&p.images.length){var f=p.images.find(function(i){return i&&(i.src||typeof i==='string');});if(f)src=typeof f==='string'?f:(f.src||'');}
    if(!src&&p.image&&p.image.src)src=p.image.src;
    if(!src&&p.featured_image)src=typeof p.featured_image==='string'?p.featured_image:(p.featured_image.src||'');
    return src||'';
  }
  function slimProduct(p){
    return {id:p.id,handle:p.handle,title:p.title,vendor:p.vendor,product_type:p.product_type,tags:p.tags,variants:p.variants||[],options:p.options||[],featured_image:rcPickImage(p)};
  }
  var RC_IDB=(function(){
    var DB='racem_catalog',STORE='cache',dbp=null;
    function open(){
      if(dbp)return dbp;
      dbp=new Promise(function(res,rej){try{if(!('indexedDB' in window)){rej();return;}var r=indexedDB.open(DB,1);r.onupgradeneeded=function(){try{r.result.createObjectStore(STORE);}catch(e){}};r.onsuccess=function(){res(r.result);};r.onerror=function(){rej(r.error);};}catch(e){rej(e);}});
      return dbp;
    }
    return {
      get:function(k){return open().then(function(db){return new Promise(function(res){try{var rq=db.transaction(STORE,'readonly').objectStore(STORE).get(k);rq.onsuccess=function(){res(rq.result||null);};rq.onerror=function(){res(null);};}catch(e){res(null);}});}).catch(function(){return null;});},
      set:function(k,v){return open().then(function(db){return new Promise(function(res){try{var tx=db.transaction(STORE,'readwrite');tx.objectStore(STORE).put(v,k);tx.oncomplete=function(){res(true);};tx.onerror=function(){res(false);};}catch(e){res(false);}});}).catch(function(){return false;});}
    };
  })();

  function fetchPage(page) {
    var ac = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = ac ? setTimeout(function () { ac.abort(); }, PAGE_TIMEOUT) : null;
    return fetch(ROOT + '/products.json?limit=250&page=' + page, {
      credentials: 'same-origin',
      cache: 'force-cache',
      signal: ac ? ac.signal : undefined
    }).then(function (res) {
      if (t) clearTimeout(t);
      if (!res.ok) return { products: [], done: true };
      return res.json().then(function (d) {
        var pp = ((d && d.products) || []).map(slimProduct);
        return { products: pp, done: pp.length < 250 };
      });
    }).catch(function () {
      if (t) clearTimeout(t);
      return { products: [], done: true };
    });
  }

  function save(raw) {
    try { RC_IDB.set(CACHE_KEY, { time: Date.now(), products: raw }); } catch (e) {}
  }

  function warm() {
    /* Ak uz je v IndexedDB cerstvy katalog, netreba nic robit. */
    RC_IDB.get(CACHE_KEY).then(function (c) {
      if (c && c.time && (Date.now() - c.time) < CACHE_TTL && Array.isArray(c.products) && c.products.length) return;
      run();
    }).catch(run);
  }

  /* Paralelne davky namiesto jednej stranky po druhej — katalog nabehne
     mnohonasobne rychlejsie, takze ked clovek klikne do Ponuky, data uz cakaju. */
  function run() {
    var seen = Object.create(null), raw = [], page = 1, BATCH = 8, stop = false;
    function batch() {
      if (stop || page > MAX_PAGES) return;
      var nums = [];
      for (var i = 0; i < BATCH && page <= MAX_PAGES; i++, page++) nums.push(page);
      Promise.all(nums.map(fetchPage)).then(function (results) {
        var added = false;
        for (var r = 0; r < results.length; r++) {
          var res = results[r];
          if (res.done) stop = true;
          for (var j = 0; j < res.products.length; j++) {
            var pr = res.products[j], k = pr.id || pr.handle;
            if (k && !seen[k]) { seen[k] = 1; raw.push(pr); added = true; }
          }
        }
        if (added) save(raw);
        batch();
      });
    }
    batch();
  }

  function start() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 3000 });
    } else {
      window.setTimeout(warm, 1200);
    }
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();